import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import Modal from "@hg/modal";
import { OneAccount, useAccount, useRole } from "@hg/one-account";
import { CustomLogin } from "./index";
var useShowLoginDialog = OneAccount.hooks.useShowLoginDialog;
var LoginModal = Modal.createContainer("_HG_SAVE_MODAL_CONTAINER");
LoginModal.rootElem.style.zIndex = "1000";
var i18nText = {
    "login.title": "選擇登入方式",
    "login.gl_title": "已完成帳號遷移",
    "login.gl_desc": "帳號登入",
    "login.lc_title": "未完成帳號遷移",
    "login.lc_desc": "帳號遷移",
    "login.no_role": "您暫時未創建遊戲角色，無法參與活動",
    "login.text_loading": "讀取資料中，請稍候……",
};
export var useCustomLogin = function (toast) {
    var t = function (path) { return i18nText[path]; };
    var showSdkLogin = useShowLoginDialog();
    var _a = useRole(), role = _a.role, roleLoading = _a.loading;
    var _b = useAccount(), account = _b.account, accountLoading = _b.loading;
    return useCallback(function () {
        if (accountLoading || roleLoading) {
            toast(t("login.text_loading"));
            return;
        }
        if (account && !role) {
            toast(t("login.no_role"));
            return;
        }
        LoginModal.show(function (_a) {
            var onClose = _a.onClose;
            return _jsx(CustomLogin, { onClose: onClose, sdkLogin: showSdkLogin });
        }, { maskClosable: true });
    }, [account, role, t, showSdkLogin, roleLoading, accountLoading]);
};
